module.exports = __webpack_public_path__ + "static/media/CW.a70bba67.png";